const setInitialBannerCounters = banners => {
  const initialCounters = {};
  if (!banners) return initialCounters;
  banners.forEach(
    ({ name, settings: { startingPoint } }) =>
      (initialCounters[name] = { total: 0, paragraphCounter: 0, insertionPoint: startingPoint })
  );
  return initialCounters;
};

export default setInitialBannerCounters;
